module.exports = __webpack_public_path__ + "assets/img/banner3.059c99f4.png";